function togglePrefooter(element) {
    element = document.querySelector('#copyright-prefooter');

    if(element.hasAttribute('is-collapsed')) {
        slideDown(element, 500, 'flex');
        element.removeAttribute('no-border');
    } else {
        slideUp(element, 500);
        setTimeout(() => {
            element.setAttribute('no-border', '');
        }, 400);
    }
}